module.exports = __webpack_public_path__ + "static/media/uppvarmning_480.67b88421.jpg";